export const login_text1 = 'Let’s create your account to get started!';
export const login_text2 =
  'By continuing, you that confirm you are 18 or older and agree to our';
export const login_text3 =
  'We may use your health info and data to improve our services and for emails, samples, and promotions; we may also share it with partners.';
export const login_text4 = 'Welcome back! Login to continue.';

export const forgot_password = 'Forget Password?';
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const email_error = {
  valid_email: 'Please enter valid email',
  require_email: 'Email is required',
};
export const password_error = 'Password is required';
export const first_name_error = 'First name is required';
export const last_name_error = 'Last name is required';

export const signup = 'Sign Up';
export const signin = 'Log In';
export const login = 'Log In';
export const name = {
  email: 'email',
  password: 'password',
  first_name: 'first_name',
  last_name: 'last_name',
  country: 'country',
};
export const placeholder = {
  email: 'Enter Email Address',
  password: 'Enter Password',
  first_name: 'Enter First Name',
  last_name: 'Enter Last Name',
  country: 'Select Country',
};

export const label_text = {
  email: 'Email Address',
  password: 'Password',
  first_name: 'First Name',
  last_name: 'Last Name',
  country: 'Select Country',
};
